import PropTypes from "prop-types";
import React from "react";
import { Grid, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

const TableCellSection = (props) => {
	const { width = 120, className = "label-table" } = props;
	return (
		<TableCell className={className}>
			<Skeleton
				sx={{
					borderRadius: "6px",
					marginBottom: "2px",
				}}
				variant="rectangular"
				width={width}
				height={18}
			/>
		</TableCell>
	);
};
TableCellSection.propTypes = {
	width: PropTypes.number,
	className: PropTypes.string,
};

const TableCellTH = (props) => {
	const { width = 120, widthTH = "4%", className = "table-cell-body" } = props;
	return (
		<TableCell component="th" scope="row" className={className} width={widthTH}>
			<Skeleton
				sx={{
					borderRadius: "6px",
				}}
				variant="rectangular"
				width={width}
				height={18}
			/>
		</TableCell>
	);
};
TableCellTH.propTypes = {
	width: PropTypes.number,
	widthTH: PropTypes.string,
	className: PropTypes.string,
};

export default function UpcomingPayPlanLoader(props) {
	const { changePayPlanBtn, deleteBtn } = props;
	return (
		<Grid item xs={12}>
			<Grid container direction="row" justifyContent={"space-between"}>
				<Grid item xs={6}>
					<Paper elevation={0} sx={{ paddingTop: "20px" }}>
						<Skeleton
							sx={{
								borderRadius: "6px",
							}}
							variant="rectangular"
							width={280}
							height={30}
						/>
					</Paper>
				</Grid>
				{changePayPlanBtn ? (
					<Grid item xs={6}>
						<Paper elevation={0} sx={{ display: "flex", justifyContent: "flex-end", paddingRight: "35px", paddingTop: "22px" }}>
							<Skeleton
								sx={{
									borderRadius: "6px",
								}}
								variant="rectangular"
								width={120}
								height={30}
							/>
						</Paper>
					</Grid>
				) : null}
				<Grid item xs={11}>
					<Paper elevation={0} sx={{ paddingBottom: "25px" }}>
						<TableContainer>
							<Table sx={{ minWidth: 750 }} style={{ width: "93%" }}>
								<TableHead>
									<TableRow>
										<TableCellSection />
										<TableCellSection width={140} />
										<TableCellSection />
										<TableCellSection />
										<TableCellSection width={140} />
									</TableRow>
								</TableHead>
								<TableBody>
									<TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
										<TableCellTH widthTH={"4%"} />
										<TableCellTH width={140} widthTH={"7%"} />
										<TableCellTH widthTH={"7%"} />
										<TableCellTH widthTH={"10%"} />
										<TableCellTH width={180} widthTH={"9%"} />
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</Paper>
				</Grid>
				{deleteBtn ? (
					<Grid item xs={1} sx={{ paddingTop: "46px" }}>
						<Paper elevation={0} style={{ marginLeft: "-58px" }}>
							<Skeleton
								sx={{
									borderRadius: "6px",
								}}
								variant="rectangular"
								width={20}
								height={25}
							/>
						</Paper>
					</Grid>
				) : null}
			</Grid>
		</Grid>
	);
}
UpcomingPayPlanLoader.propTypes = {
	changePayPlanBtn: PropTypes.bool,
	deleteBtn: PropTypes.bool,
};
